export default "__VITE_ASSET__B7YaMsEV__"